import api from '../api';
import { UserBase, UserRoleBase } from '../../models/user';

interface ICreateUserProps {
  bio?: string;
  email: string;
  name: string;
  password: string;
  passwordConfirmation: string;
  phone?: string;
  userRoles: UserRoleBase[];
}

export interface INewUser extends UserBase {
  userRoles: UserRoleBase[];
}

export const createUsersService = async ({
  bio,
  email,
  name,
  password,
  passwordConfirmation,
  phone,
  userRoles,
}: ICreateUserProps): Promise<INewUser> => {
  const { data } = await api.post<INewUser>('/users', {
    bio,
    email,
    name,
    password,
    passwordConfirmation,
    phone,
    userRoles,
  });

  return data;
};
